var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4247 11.1035V13.0866M12.4247 15.0698V13.0866M12.4247 13.0866H10.5381M12.4247 13.0866H14.332",
    strokeWidth: 1.095,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9046 15.0042H1.48092C1.21531 15.0042 1 14.7889 1 14.5233V1.85915C1 1.59355 1.21531 1.37823 1.48092 1.37823H10.6451C10.9107 1.37823 11.126 1.59355 11.126 1.85915V7.2294",
    strokeWidth: 1.095,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0874 4.16095H6.98818",
    strokeWidth: 1.095,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0874 6.24866H8.65397",
    strokeWidth: 1.095,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0874 9.03223H7.26233",
    strokeWidth: 1.095,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4349,
    cy: 13.0531,
    r: 4.02122,
    strokeWidth: 1.095
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContent);
export default __webpack_public_path__ + "static/media/AddContent.51b7deb596c7e08136a3342ac38152ce.svg";
export { ForwardRef as ReactComponent };